export default "__VITE_ASSET__CoTKdUPC__"